<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
<!--      <span-->
<!--        class="main-r_top_nav"-->
<!--        :class="mainStatus === 'apiTest' && 'active'"-->
<!--        @click.stop="handleClick('apiTest')"-->
<!--      >{{$t('apiDoc.测试工具')}}</span>-->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

// import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'

const apiUrlTest = '';
export default {
  components: { onlineDoc , apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.weightApi')}`,
        //接口地址
        testApi: ``,
        proApi: ``,
        //参数描述  START
        postDataList:[

          //   请求头参数
          {
            title:'Headers',
            value:[
              {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`,},
              {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`,},
              {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,},
            ]
          },
          {
            title:`${this.$t('onlineDoc.请求参数')}`,
            value:[
              {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
            ]
          },
          {
            title:`${this.$t('onlineDoc.业务参数')}`,
            value:[
              {name: "billCode",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单编号')}`},
              {name: "length",type: "int(6)",require: "N",normal: "",describe: `${this.$t('onlineDoc.长，cm')}`},
              {name: "width",type: "int(6)",require: "N",normal: "",describe: `${this.$t('onlineDoc.宽，cm')}`},
              {name: "height",type: "int(6)",require: "N",normal: "",describe: `${this.$t('onlineDoc.高，cm')}`},
              {name: "packageInsideChargeWeight",type: "String(32)",require: "N",normal: "",describe: `${this.$t('onlineDoc.计费重量')}`},
            ]
          }

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[

          //   响应参数
          {
            title:`${this.$t('onlineDoc.响应参数')}`,
            value:[
              { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`,},
              {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`,},
              {name: "data",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`,},
            ]
          },
        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {"billCodes":"UT0000352320970,UT0000359748995,UT0000353613157"}`,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success",
    "data": [
        {
            "billCode": "UT0000352320970",
            "details": [
                {
                    "billCode": "UT0000352320970",
                    "scanTime": "2020-07-18 08:53:05",
                    "desc": "包裹已签收！签收人是【本人签收】，如有疑问请联系：13123456789，如需联系网点请拨打：17314954950 特  殊时期，极兔从不懈怠，感谢使用，我们时刻准备，再次为您服务！",
                    "scanType": "快件签收",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京玄武网点",
                    "scanNetworkId": 33,
                    "staffName": "test1042",
                    "staffContact": "13123456789",
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "玄武区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000352320970",
                    "scanTime": "2020-07-18 08:52:53",
                    "desc": "快件离开【南京转运中心】已发往【南京玄武网点】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "发件扫描",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京转运中心",
                    "scanNetworkId": 24,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京玄武网点",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000352320970",
                    "scanTime": "2020-07-18 08:52:51",
                    "desc": "快件到达【南京转运中心】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "到件扫描",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京转运中心",
                    "scanNetworkId": 24,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京转运中心",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000352320970",
                    "scanTime": "2020-07-18 08:52:50",
                    "desc": "快件离开【南京雨花台春江新城网点】已发往【南京转运中心】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "发件扫描",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京转运中心",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000352320970",
                    "scanTime": "2020-07-18 08:52:48",
                    "desc": "包裹顺利到达【南京雨花台春江新城网点】15850664590，放心交给极兔小哥吧！",
                    "scanType": "入仓扫描",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000352320970",
                    "scanTime": "2020-07-18 08:52:43",
                    "desc": "【南京雨花台春江新城网点】您的极兔小哥test1040(13123456789)已取件。如需联系网点，请拨打   15850664590 特殊时期，您的牵挂，让极兔小哥为您速递！ᕱ⑅ᕱ",
                    "scanType": "快件揽收",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": "test1040",
                    "staffContact": "13123456789",
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                }
            ]
        },
        {
            "billCode": "UT0000359748995",
            "details": [
                {
                    "billCode": "UT0000359748995",
                    "scanTime": "2020-07-18 08:53:05",
                    "desc": "包裹已签收！签收人是【本人签收】，如有疑问请联系：13123456789，如需联系网点请拨打：17314954950 特  殊时期，极兔从不懈怠，感谢使用，我们时刻准备，再次为您服务！",
                    "scanType": "快件签收",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京玄武网点",
                    "scanNetworkId": 33,
                    "staffName": "test1042",
                    "staffContact": "13123456789",
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "玄武区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000359748995",
                    "scanTime": "2020-07-18 08:52:53",
                    "desc": "快件离开【南京转运中心】已发往【南京玄武网点】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "发件扫描",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京转运中心",
                    "scanNetworkId": 24,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京玄武网点",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000359748995",
                    "scanTime": "2020-07-18 08:52:51",
                    "desc": "快件到达【南京转运中心】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "到件扫描",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京转运中心",
                    "scanNetworkId": 24,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京转运中心",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000359748995",
                    "scanTime": "2020-07-18 08:52:50",
                    "desc": "快件离开【南京雨花台春江新城网点】已发往【南京转运中心】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "发件扫描",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京转运中心",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000359748995",
                    "scanTime": "2020-07-18 08:52:48",
                    "desc": "包裹顺利到达【南京雨花台春江新城网点】15850664590，放心交给极兔小哥吧！",
                    "scanType": "入仓扫描",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000359748995",
                    "scanTime": "2020-07-18 08:52:43",
                    "desc": "【南京雨花台春江新城网点】您的极兔小哥test1040(13123456789)已取件。如需联系网点，请拨打   15850664590 特殊时期，您的牵挂，让极兔小哥为您速递！ᕱ⑅ᕱ",
                    "scanType": "快件揽收",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": "test1040",
                    "staffContact": "13123456789",
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                }
            ]
        },
        {
            "billCode": "UT0000353613157 ",
            "details": [
                {
                    "billCode": "UT0000353613157 ",
                    "scanTime": "2020-07-18 08:53:05",
                    "desc": "包裹已签收！签收人是【本人签收】，如有疑问请联系：13123456789，如需联系网点请拨打：17314954950 特  殊时期，极兔从不懈怠，感谢使用，我们时刻准备，再次为您服务！",
                    "scanType": "快件签收",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京玄武网点",
                    "scanNetworkId": 33,
                    "staffName": "test1042",
                    "staffContact": "13123456789",
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "玄武区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000353613157 ",
                    "scanTime": "2020-07-18 08:52:53",
                    "desc": "快件离开【南京转运中心】已发往【南京玄武网点】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "发件扫描",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京转运中心",
                    "scanNetworkId": 24,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京玄武网点",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000353613157 ",
                    "scanTime": "2020-07-18 08:52:51",
                    "desc": "快件到达【南京转运中心】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "到件扫描",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京转运中心",
                    "scanNetworkId": 24,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京转运中心",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000353613157 ",
                    "scanTime": "2020-07-18 08:52:50",
                    "desc": "快件离开【南京雨花台春江新城网点】已发往【南京转运中心】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "发件扫描",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京转运中心",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000353613157 ",
                    "scanTime": "2020-07-18 08:52:48",
                    "desc": "包裹顺利到达【南京雨花台春江新城网点】15850664590，放心交给极兔小哥吧！",
                    "scanType": "入仓扫描",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000353613157 ",
                    "scanTime": "2020-07-18 08:52:43",
                    "desc": "【南京雨花台春江新城网点】您的极兔小哥test1040(13123456789)已取件。如需联系网点，请拨打   15850664590 特殊时期，您的牵挂，让极兔小哥为您速递！ᕱ⑅ᕱ",
                    "scanType": "快件揽收",
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": "test1040",
                    "staffContact": "13123456789",
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                }
            ]
        }
    ]
}`),

        //错误代码提示
        errcodeJson: []
      },

      apiTestData: {
        _headerData: {
          apiAccount: "1001",
          digest: "U40e5sumorgd3YgZzU61Mw==",
          timestamp: "1565238848921",
        },
        data:{
          bizContent: `{"billCodes":"UT0000352320970,UT0000359748995,UT0000353613157"}`,
        },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: [{code:'145003100',msg:`${this.$t('apiTestDoc.运单号非法')}`},
          {code:'145003502',msg:`${this.$t('apiTestDoc.运单号个数超过30')}`}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
